<template>
  <div class="pay-result container">
    <div class="result-area">
      <div class="result-title fl-center">
        <el-image :src="rightIcon"></el-image>
        <span>支付成功 Pay Success</span>
      </div>
      <div class="result-btns fl-center">
        <el-button class="result-btn-item mar-r-100" @click="toShopIndex">
          再逛逛 And hang out
        </el-button>
        <el-button class="result-btn-item" @click="toOrder">
          查看订单 Look at the order
        </el-button>
      </div>
    </div>
    <div class="guide-list">
      <GuideList :goodsList="goodsList" />
    </div>
  </div>
</template>

<script>
import GuideList from "@/components/base/GuideList.vue";
import rightIcon from "@/assets/img/right-icon.png";
export default {
  name: "PayResult",
  components: { GuideList },
  data() {
    return {
      rightIcon: rightIcon,
      goodsList: [],
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.getGoodsList();
  },
  methods: {
    toShopIndex() {
      this.$router.replace("/e-shop");
    },
    toOrder() {
      this.$router.replace("/my-profile/order");
    },

    async getGoodsList() {
      const params = {
        sceneMarketSwitch: 1,
        page: 1,
        pageSize: 3,
      };
      let {
        data: { list, total },
      } = await this.$api.getGoodsList(params);
      list = (list || []).slice(0, 3);
      this.goodsList = list.map((item) => {
        return item;
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.pay-result {
  background: #fff;
  .result-title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    margin-top: 104px;
    text-align: center;
    padding-left: 60px;
    .el-image {
      width: 30px;
      height: 30px;
      margin-right: 30px;
    }
  }
  .result-btns {
    margin-top: 100px;
  }
  .mar-r-100 {
    margin-right: 100px;
  }
  .guide-list {
    margin-top: 100px;
    padding-bottom: 90px;
  }
}
</style>
